import styled from "styled-components";
import { Body } from "@/styles/typography";

const Section = styled.div`
  margin: 24px 0 48px;
`;

const Container = styled.div`
  display: grid;
  gap: 8px;
  margin-top: 24px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

const Card = styled.a`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.brown};
  border-radius: 14px;
  text-decoration: none;
  padding: 16px 24px;
  width: 100%;

  svg {
    opacity: 0.75;
    transition: all 0.2s ease-in-out;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    &:hover {
      svg {
        opacity: 1;
      }
    }
  }
`;

const CardDate = styled(Body)`
  opacity: 0.75;
`;

const S = {
  Section,
  Container,
  Card,
  CardDate,
};

export default S;
